import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export enum EventGuestScannerViewEnum {
  Start = 'start',
  Scanner = 'scanner',
  Result = 'result',
  History = 'history',
}

@Injectable({
  providedIn: 'root',
})
export class GbEventGuestScannerViewService {
  private viewShowingSubject$ = new BehaviorSubject<EventGuestScannerViewEnum>(EventGuestScannerViewEnum.Start)
  private previousViewShowingSubject$ = new BehaviorSubject<EventGuestScannerViewEnum | null>(null)
  viewShowing$ = this.viewShowingSubject$.asObservable()

  setViewShowing(view: EventGuestScannerViewEnum): void {
    this.previousViewShowingSubject$.next(this.viewShowingSubject$.value)
    this.viewShowingSubject$.next(view)
  }

  goToPreviousView(): void {
    const previousView = this.previousViewShowingSubject$.value
    if (previousView) this.setViewShowing(previousView)
  }

  resetViewShowing(): void {
    this.previousViewShowingSubject$.next(null)
    this.viewShowingSubject$.next(EventGuestScannerViewEnum.Start)
  }
}
